// src/components/Login.js
import React from 'react';
import { Button, Container, Typography } from '@mui/material';
import config from '../config/config'; // Import the config file

//axios.defaults.withCredentials = true;

function Login() {
  
 const handleGoogleLogin = () => {
    window.location.href = `${config.apiUrl}/authorize`;
  }
  
  return (
    <Container
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: 'white', // White background
      }}
    >
      <Typography variant="h4" component="h1" gutterBottom>
        Please login to continue
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleGoogleLogin}
        startIcon={<img
      src="/google-icon.png" // Update the path to your image
      alt="Google Logo"
      style={{ width: '3vh', height: '3vh' }} // Adjust the width and height as needed
    />}
      >
        Log in with Google
      </Button>
    </Container>
  );
};

export default Login;
